import React from "react";
import FormationBuilderPage from "../FormationBuilderPage";

const SoftwareDeveloper = () => {
  const softwareDeveloperProgram = [
    {
      title: "Continuous Integration / Continuous Delivery (CI / CD)",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "BSP UBoot et Linux embarqué (YOCTO)",
      img: "/assets/images/icon/tuyaux.svg",
    },
    {
      title: "OS Temps réel / FreeRTOS",
      img: "/assets/images/icon/work.svg",
    },
    {
      title: "Les Méthodes agiles",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Animation de réunion",
      img: "/assets/images/icon/work-women.svg",
    },
    {
      title: "Redaction de synthèse",
      img: "/assets/images/icon/redaction.svg",
    },
    {
      title: "Prise de parole",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Management de projet",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Logiciels de planification et de gestion JIRA",
      img: "/assets/images/icon/balance.svg",
    },
    {
      title: "Linux / BASH",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Réseaux: Ethernet / Bus CAN",
      img: "/assets/images/icon/network-card.svg",
    },
    {
      title: "Algorithmique",
      img: "/assets/images/icon/component-card.svg",
    },
    {
      title: "Debug GDB / DDD/ ASAN",
      img: "/assets/images/icon/setting.svg",
    },
    {
      title: "Matlab / Simulink",
      img: "/assets/images/icon/setting.svg",
    },
    {
      title: "SYSML",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Validation et Tests des Logiciels",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "La gestion des exigences avec DOORS",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Autosar (Automotive Open System Architecture)",
      img: "/assets/images/icon/setting-square.svg",
    },
    {
      title: "Projet de fin cursus",
      img: "/assets/images/icon/light.svg",
    },
  ];

  return (
    <FormationBuilderPage
      category="Automobile"
      titleColor="#2424FF"
      title="Software Developer"
      duration={11}
      description={
        <React.Fragment>
          <p>
            Grâce au partenariat entre Liora et SEGULA Technologies, rejoignez
            un groupe d’ingénierie mondiale à forte croissance en tant que
            Software Developer, après une formation accélérée de 11 semaines.
          </p>
          <p>
            Impression 3D, réalité augmentée, véhicule autonome, usine du
            futur... rythment le quotidien de nos 13 000 ingénieux
            collaborateurs, pourquoi pas le vôtre ?
          </p>
        </React.Fragment>
      }
      image="/assets/images/home/automobile.png"
      program={softwareDeveloperProgram}
      formId="579c6f97-2c06-4ec0-ba1f-742922cc6853"
    />
  );
};

export default SoftwareDeveloper;
